import {useDebugValue} from 'react';

import {useOptions} from './';

const defaultOptions = {
    smallBreakpoint: 768,
    largeBreakpoint: 1200
};

function useMediaOptions(props) {
    const {
        mediaOptions: propsOptions
    } = props;

    const {
        options
    } = useOptions(defaultOptions, propsOptions);

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useMediaOptions};
